import Alpine from 'alpinejs'
import searchSite from './siteSearch'


const components = {
  searchSite
};

Object.entries(components).forEach(([name, module]) => {
  Alpine.data(name, module);
});

window.Alpine = Alpine;
Alpine.start();
